import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import "./styles/navBar.css";

const NavBar = (props) => {
	const { active } = props;
	const [docked, setDocked] = useState(false);
	const [menuOpen, setMenuOpen] = useState(false);

	// Once the reader scrolls past the hero, glide the top pill to the side on
	// desktop, or collapse it into a hamburger on mobile, so it stops competing
	// with the text. It returns to the full top pill when scrolled back.
	useEffect(() => {
		const onScroll = () => {
			const top =
				window.scrollY || document.documentElement.scrollTop || 0;
			const isDocked = top > 120;
			setDocked(isDocked);
			// Back at the hero the full pill is showing, so any open mobile
			// dropdown should close with it.
			if (!isDocked) setMenuOpen(false);
		};
		window.addEventListener("scroll", onScroll, { passive: true });
		onScroll();
		return () => window.removeEventListener("scroll", onScroll);
	}, []);

	const navClass = `navbar${docked ? " docked" : ""}${
		menuOpen ? " menu-open" : ""
	}`;

	return (
		<React.Fragment>
			<div className="nav-container">
				<nav className={navClass}>
					<button
						className="nav-toggle"
						aria-label="Toggle navigation menu"
						aria-expanded={menuOpen}
						onClick={() => setMenuOpen((open) => !open)}
					>
						<span className="nav-toggle-bar" />
						<span className="nav-toggle-bar" />
						<span className="nav-toggle-bar" />
					</button>
					<div className="nav-background">
						<ul
							className="nav-list"
							onClick={() => setMenuOpen(false)}
						>
							<li
								className={
									active === "home"
										? "nav-item active"
										: "nav-item"
								}
							>
								<Link to="/">Home</Link>
							</li>
							<li
								className={
									active === "about"
										? "nav-item active"
										: "nav-item"
								}
							>
								<Link to="/about">About</Link>
							</li>
							<li
								className={
									active === "projects"
										? "nav-item active"
										: "nav-item"
								}
							>
								<Link to="/projects">Projects</Link>
							</li>
							<li
								className={
									active === "articles"
										? "nav-item active"
										: "nav-item"
								}
							>
								<Link to="/articles">Articles</Link>
							</li>
							<li
								className={
									active === "tools"
										? "nav-item active"
										: "nav-item"
								}
							>
								<Link to="/tools">Tools</Link>
							</li>
							<li
								className={
									active === "contact"
										? "nav-item active"
										: "nav-item"
								}
							>
								<Link to="/contact">Contact</Link>
							</li>
						</ul>
					</div>
				</nav>
			</div>
		</React.Fragment>
	);
};

export default NavBar;
